import { ApiState } from '../../shared/models/api-state.model';
import { ActionReducer, createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { REPROCESS_API_ACTIONS } from '../actions/reprocess.actions';

const REPROCESS_STATE_KEY = 'reprocess';

export interface IReprocessState {
  reprocess: ApiState;
}

export const reprocessInitialState: IReprocessState = { reprocess: new ApiState() };

const reducer: ActionReducer<IReprocessState> = createReducer<IReprocessState>(
  reprocessInitialState,
  on(REPROCESS_API_ACTIONS.reprocess, (state) => ({ ...state, reprocess: state.reprocess.load() })),
  on(REPROCESS_API_ACTIONS.success, (state) => ({ ...state, reprocess: state.reprocess.success(null) })),
  on(REPROCESS_API_ACTIONS.error, (state, { error }) => ({ ...state, reprocess: state.reprocess.setError(error) })),
);

export const REPROCESS_REDUCER = createFeature({
  name: REPROCESS_STATE_KEY,
  reducer,
  extraSelectors: ({ selectReprocess }) => ({
    isLoading: createSelector(selectReprocess, ({ loading }) => loading),
  }),
});
